const Card = ({title, description, date, skills, links}) => {

return (
    <div className="
            flex flex-col flex-1 text-gray-100
            bg-gradient-to-br from-[#222] to-gray-800 w-full max-w-4xl mt-6 p-4 sm:p-6 lg:p-8
            items-center justify-center rounded-2xl
            border-2 border-gray-700 shadow-2xl transition-transform hover:scale-105">
        <h2 className="text-lg sm:text-xl lg:text-2xl font-semibold mb-3 tracking-wide text-gray-100 text-center">{title}</h2>
        <p className="text-sm sm:text-base mb-5 text-center text-gray-300">{description}</p>
        <div className="flex flex-wrap gap-2 mb-4 justify-center max-w-full">
            {skills && skills.map((skill, idx) => (
                <span
                    key={idx}
                    className="bg-gray-700 text-blue-200 px-2 sm:px-3 py-1 rounded-full text-xs font-medium shadow"
                >
                    {skill}
                </span>
            ))}
        </div>
        <div className="flex flex-wrap gap-2 sm:gap-3 mb-4 justify-center max-w-full">
            {links && links.map((link, idx) => (
                <a
                    key={idx}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-gray-900 border border-blue-700 text-blue-300 px-3 sm:px-4 py-1 rounded-lg text-xs font-semibold shadow hover:bg-blue-900 transition"
                >
                    {link.label}
                </a>
            ))}
        </div>
        <span className="text-xs sm:text-sm text-gray-400 italic text-center">{date}</span>
    </div>
)
}

export default Card